import { safeLocalStorage } from './storageUtils';
import { type PendingUserAccountItem } from '../types/types';
import { PENDING_USER_ACCOUNT_ITEM_KEY } from '../consts/consts';

export const readPendingUserAccountItem = (): PendingUserAccountItem | null => {
  const pendingUserAccountItem = safeLocalStorage.getItem(PENDING_USER_ACCOUNT_ITEM_KEY);
  if (!pendingUserAccountItem) return null;

  try {
    return JSON.parse(pendingUserAccountItem) as PendingUserAccountItem;
  } catch (error) {
    safeLocalStorage.removeItem(PENDING_USER_ACCOUNT_ITEM_KEY);
    throw error;
  }
};
